import React, { useEffect, useState } from "react";
import { api, fmtError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Github, FileText, DatabaseZap, Clock } from "lucide-react";
import { toast } from "sonner";

export default function Sources() {
  const [data, setData] = useState({ inventaire: [], connexions: [] });

  const load = () => api.get("/sources").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const request = async (type) => {
    try {
      await api.post("/sources/connect-request", { type, note: "Demande de connexion initiée depuis TECA BUILD 360" });
      toast.success("Demande enregistrée — fournissez un token en lecture seule pour lancer l'audit.");
      load();
    } catch (e) { toast.error(fmtError(e)); }
  };

  return (
    <div className="space-y-5" data-testid="sources-page">
      <div>
        <h1 className="font-display text-3xl font-extrabold uppercase tracking-tight">Connecter mes sources</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Audit de l'écosystème TECA (GitHub multi-comptes, Manus AI) — droits de lecture uniquement. Aucun mot de passe, secret ou clé privée n'est demandé.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 gap-3">
        <div className="bg-card rounded-xl border-2 border-border p-5 space-y-3">
          <div className="flex items-center gap-2"><Github className="h-6 w-6" /><span className="font-display font-bold text-lg uppercase">GitHub</span></div>
          <p className="text-sm text-muted-foreground">Inventaire des repositories, branches, releases ; recherche TECA / chantier / devis / CRM / transport… Lecture seule, aucun droit d'écriture.</p>
          <Button data-testid="connect-github" onClick={() => request("github")} className="w-full h-13 bg-teca-900 text-white font-bold hover:bg-slate-800">
            + Connecter un compte GitHub
          </Button>
          <p className="text-[10px] text-muted-foreground">Un token GitHub en lecture seule (fine-grained, scopes read-only) sera demandé à Xavier CAREY au moment de l'audit.</p>
        </div>
        <div className="bg-card rounded-xl border-2 border-border p-5 space-y-3">
          <div className="flex items-center gap-2"><FileText className="h-6 w-6 text-amber-600" /><span className="font-display font-bold text-lg uppercase">Manus AI</span></div>
          <p className="text-sm text-muted-foreground">Projets, cahiers des charges, exports ZIP/PDF/JSON ou liens de partage Manus.</p>
          <Button data-testid="connect-manus" onClick={() => request("manus")} variant="outline" className="w-full h-13 font-bold">
            + Demander l'accès / export Manus
          </Button>
          <p className="text-[10px] text-muted-foreground">Si aucun accès automatisé n'existe, Xavier fournira un export de projet.</p>
        </div>
      </div>

      {data.connexions.length > 0 && (
        <section className="bg-card rounded-xl border border-border p-4">
          <h2 className="font-display text-lg font-bold uppercase mb-2">Demandes de connexion</h2>
          {data.connexions.map((c) => (
            <div key={c.id} className="flex items-center gap-2 text-sm py-1.5" data-testid={`connexion-${c.id}`}>
              <Clock className="h-4 w-4 text-amber-600" />
              <span className="font-bold uppercase">{c.type}</span>
              <span className="text-muted-foreground">— {c.statut} — {new Date(c.created_at).toLocaleDateString("fr-FR")}</span>
            </div>
          ))}
        </section>
      )}

      <section className="bg-card rounded-xl border border-border overflow-x-auto">
        <div className="flex items-center gap-2 p-5 pb-2">
          <DatabaseZap className="h-5 w-5 text-amber-600" />
          <h2 className="font-display text-lg font-bold uppercase">Source Inventory — Audit écosystème</h2>
        </div>
        <table className="w-full text-sm min-w-[820px]" data-testid="source-inventory-table">
          <thead className="bg-teca-900 text-white text-xs uppercase">
            <tr><th className="text-left px-3 py-2.5">Source</th><th className="text-left px-3 py-2.5">Type</th><th className="text-left px-3 py-2.5">Fonction</th><th className="text-left px-3 py-2.5">État</th><th className="text-left px-3 py-2.5">Pertinence</th><th className="text-left px-3 py-2.5">Destination TECA BUILD 360</th></tr>
          </thead>
          <tbody className="divide-y divide-border">
            {data.inventaire.map((s) => (
              <tr key={s.id} data-testid={`source-row-${s.id}`}>
                <td className="px-3 py-2.5 font-semibold text-xs">{s.repository}</td>
                <td className="px-3 py-2.5 text-xs">{s.source_type}</td>
                <td className="px-3 py-2.5 text-xs">{s.fonction}</td>
                <td className="px-3 py-2.5"><span className="bg-emerald-100 dark:bg-emerald-950 text-emerald-800 dark:text-emerald-200 text-[10px] font-bold px-2 py-1 rounded uppercase">{s.etat}</span></td>
                <td className="px-3 py-2.5 text-xs">{s.pertinence_teca}</td>
                <td className="px-3 py-2.5 text-xs font-semibold">{s.destination}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </div>
  );
}
